<template>
  <div
    class="accent w-full h-full d-flex align-center justify-center hover-pointer black--text"
    @click.stop="click"
  >
    <v-icon size="20"> mdi-alert-outline </v-icon>
    <div class="body-2 d-flex">
      <span class="font-weight-bold">{{ lead }} - </span>
      <div
        class="ml-1"
        v-html="message"
      />
    </div>
  </div>
</template>

<script>
import { DRAWERS } from '../../utils/constants';

export default {
  name: 'SubscriptionPastDueAlert',

  data() {
    return {};
  },

  computed: {
    /*
     * A team member sees this banner too, and cannot act on it.
     *
     * UserPlanDetail is inherited from the collection owner (McsUserService.Transform), so a
     * member's `subscriptionIsPastDue` is really their ADMIN's failed payment - while the
     * subscription, the invoice and every card sit on the admin's Stripe customer. The banner
     * used to tell all of them to "update your payment and retry", which is an instruction only
     * one of them can follow. Everyone else clicked it, typed a card in, and was told there was
     * no Stripe customer on file.
     *
     * Same gate as config.js's `disableAlertBar` check: a teams user who is not the admin.
     * Deliberately NOT `!isCollectionOwner` on its own - a solo subscriber is neither a teams
     * user nor an admin, and they are the person the banner exists for.
     */
    isTeamMember() {
      return (
        this.$store.getters['user/isTeamsUser'] &&
        !this.$store.getters['user/isCollectionOwner']
      );
    },

    lead() {
      return this.isTeamMember ? "Your team's account is past due" : 'This account is past due';
    },

    /*
     * Both variants still click through to the same place. The retry screen resolves who owns
     * the billing and, for a member, names that person with a prefilled email to them - so the
     * banner does not need the owner's name (which the dashboard's own state does not carry) to
     * lead somewhere useful.
     */
    message() {
      if (this.isTeamMember) {
        return '<span class="primary--text">click here</span> to see who can restore it!';
      }
      return '<span class="primary--text">click here</span> to update your payment and retry!';
    }
  },

  methods: {
    click() {
      // Open the CheckoutSubscriptionApp embed in retry-payment mode so the user can
      // add a new card (or pick a saved one) and pay the overdue invoice in place.
      // A member reaching the same screen gets the "billed to <owner>" explanation
      // instead of a card form.
      // dispatch (not commit) so drawers/open routes it through <mcs-checkout-subscription>.
      this.$store.dispatch('drawers/open', {
        drawerId: DRAWERS.RETRY_PAYMENT_DRAWER,
        data: { source: 'dashboard_pastdue_banner' }
      });
    }
  }
};
</script>

<style></style>
